import { render, staticRenderFns } from "./liveSegmentList.vue?vue&type=template&id=9d536cc8&"
import script from "./liveSegmentList.vue?vue&type=script&lang=js&"
export * from "./liveSegmentList.vue?vue&type=script&lang=js&"
import style0 from "./liveSegmentList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports